import React, { useState, useEffect } from "react";
import { Button, Navbar, Dropdown, Footer } from "flowbite-react";
import { Link } from "react-router-dom";
import logo from "../assets/logo.webp";
import { BsLinkedin, BsInstagram, BsTwitter } from "react-icons/bs";
import { HiAcademicCap, HiOutlinePresentationChartBar } from "react-icons/hi";

function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [filteredCountries, setFilteredCountries] = useState([]);
  const [filteredCourses, setFilteredCourses] = useState([]);
  const [isNavbarOpen, setIsNavbarOpen] = useState(false);

  const hardcodedCountries = [
    { c_id: "u007", c_name: "USA" },
    { c_id: "f004", c_name: "Germany" },
    { c_id: "u005", c_name: "UAE" },
    { c_id: "a001", c_name: "Australia" },
    { c_id: "c002", c_name: "Canada" },
    { c_id: "u006", c_name: "UK" },
    { c_id: "f003", c_name: "France" },
    { c_id: "u008", c_name: "Russia" },
    { c_id: "u009", c_name: "Switzerland" },
    { c_id: "u010", c_name: "India" },
  ];

  const courses = [
    { courseId: "course010", courseName: "Medicine" },
    { courseId: "course001", courseName: "Business Administration" },
    { courseId: "course002", courseName: "Data Science/Analytics and Machine Learning" },
    { courseId: "course003", courseName: "Computer Science/IT" },
    { courseId: "course004", courseName: "Engineering" },
    { courseId: "course005", courseName: "Economics" },
    { courseId: "course006", courseName: "Public Health" },
    { courseId: "course007", courseName: "Psychology" },
    { courseId: "course008", courseName: "Finance" },
    { courseId: "course009", courseName: "Law" },
  ];

  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY;
      setIsScrolled(scrollPosition > 0);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleSearch = (e) => {
    const query = e.target.value.toLowerCase();
    setSearchQuery(query);
    if (query === "") {
      setFilteredCountries([]);
      setFilteredCourses([]);
    } else {
      setFilteredCountries(
        hardcodedCountries.filter((country) =>
          country.c_name.toLowerCase().includes(query)
        )
      );
      setFilteredCourses(
        courses.filter((course) =>
          course.courseName.toLowerCase().includes(query)
        )
      );
    }
  };

  const handleCountryClick = () => {
    setSearchQuery("");
    setFilteredCountries([]);
    setFilteredCourses([]);
    setIsNavbarOpen(false);
  };

  const handleCourseClick = () => {
    setSearchQuery("");
    setFilteredCountries([]);
    setFilteredCourses([]);
    setIsNavbarOpen(false);
  };

  return (
    <Navbar
      fluid
      rounded
      className={`relative top-0 w-full z-50 shadow-md ${isScrolled ? "bg-white" : "bg-transparent"
        } transition-all duration-300`}
    >
      {/* Logo */}
      <Navbar.Brand href="/" className="flex items-center">
        <img
          src={logo}
          className="mr-3 h-14 md:h-16 lg:h-20"
          alt="Unithink"
        />
      </Navbar.Brand>

      {/* Search Bar - centered on desktop, full width on mobile */}
      <div className="flex-1 mx-4 relative hidden md:block">
        <input
          type="text"
          value={searchQuery}
          onChange={handleSearch}
          placeholder="Search countries or courses..."
          className="w-full border border-gray-300 rounded-lg p-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
        />
        {(filteredCountries.length > 0 || filteredCourses.length > 0) &&
          searchQuery !== "" && (
            <div className="absolute top-full left-0 w-full bg-white shadow-lg z-20">
              {filteredCountries.map((country) => (
                <Link key={country.c_id} to={`/countrydetail/${country.c_id}`}>
                  <div
                    onClick={handleCountryClick}
                    className="p-2 hover:bg-gray-100 cursor-pointer"
                  >
                    {country.c_name}
                  </div>
                </Link>
              ))}
              {filteredCourses.map((course) => (
                <Link
                  key={course.courseId}
                  to={`/coursedetail/${course.courseId}`}
                >
                  <div
                    onClick={handleCourseClick}
                    className="p-2 hover:bg-gray-100 cursor-pointer"
                  >
                    {course.courseName}
                  </div>
                </Link>
              ))}
            </div>
          )}
      </div>

      {/* Right side (Counseling + Toggle) */}
      <div className="flex items-center ml-4 space-x-2 md:order-2">
        <Link to="/counseling">
          <Button gradientDuoTone="pinkToOrange" outline pill>
            Counseling
          </Button>
        </Link>
        <Navbar.Toggle onClick={() => setIsNavbarOpen((prev) => !prev)} />
      </div>

      {/* Navbar Items */}
      <Navbar.Collapse
        className={`md:flex md:mt-7 md:w-auto ${isNavbarOpen ? "block" : "hidden"} text-center md:text-left`}
      >
        {/* Search bar for mobile */}
        <div className="block md:hidden w-full px-2 mb-2">
          <input
            type="text"
            value={searchQuery}
            onChange={handleSearch}
            placeholder="Search countries or courses..."
            className="w-full border border-gray-300 rounded-lg p-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
          {(filteredCountries.length > 0 || filteredCourses.length > 0) &&
            searchQuery !== "" && (
              <div className="bg-white shadow-lg z-20">
                {filteredCountries.map((country) => (
                  <Link key={country.c_id} to={`/countrydetail/${country.c_id}`}>
                    <div
                      onClick={handleCountryClick}
                      className="p-2 hover:bg-gray-100 cursor-pointer"
                    >
                      {country.c_name}
                    </div>
                  </Link>
                ))}
                {filteredCourses.map((course) => (
                  <Link
                    key={course.courseId}
                    to={`/coursedetail/${course.courseId}`}
                  >
                    <div
                      onClick={handleCourseClick}
                      className="p-2 hover:bg-gray-100 cursor-pointer"
                    >
                      {course.courseName}
                    </div>
                  </Link>
                ))}
              </div>
            )}
        </div>

        {/* Links */}
        <Navbar.Link as="div" className="flex items-center cursor-pointer">
          <Dropdown
            inline
            label={
              <span className="text-gray-800 hover:text-blue-500 transition duration-300 py-2 block font-medium">
                SAS
              </span>
            }
            arrowIcon={true}
          >
            <Dropdown.Header className="bg-gray-50 border-b">
              <span className="block text-xs font-bold text-blue-600 tracking-wider uppercase">SAS Programs</span>
            </Dropdown.Header>
            <div className="p-1">
              <Dropdown.Item
                icon={HiOutlinePresentationChartBar}
                as={Link}
                to="/sas"
              >
                <span className="ml-2 font-medium">SAS Training</span>
              </Dropdown.Item>
              <Dropdown.Item
                icon={HiAcademicCap}
                as={Link}
                to="/svyasa"
              >
                <span className="ml-2 font-medium">MBA with SAS</span>
              </Dropdown.Item>
            </div>
          </Dropdown>
        </Navbar.Link>
        <Navbar.Link>
          <Link to="/countries" className="text-gray-800 hover:text-blue-500 transition duration-300 py-2 block">
            Countries
          </Link>
        </Navbar.Link>
        <Navbar.Link>
          <Link to="/assessments" className="text-gray-800 hover:text-blue-500 transition duration-300 py-2 block">
            Assessments
          </Link>
        </Navbar.Link>
        <Navbar.Link>
          <Link to="/about" className="text-gray-800 hover:text-blue-500 transition duration-300 py-2 block">
            About
          </Link>
        </Navbar.Link>
        <Navbar.Link>
          <Link to="/contact" className="text-gray-800 hover:text-blue-500 transition duration-300 py-2 block">
            Contact
          </Link>
        </Navbar.Link>

        {/* Social Icons */}
        <div className=" flex justify-center md:justify-start py-2">
          <Navbar.Link>
            <a
              href="https://www.linkedin.com/company/unithink-education-international/"
              target="_blank"
              rel="noopener noreferrer"
              className="text-gray-800 mr-8 hover:text-blue-500 transition duration-300 text-xl"
            >
              <BsLinkedin />
            </a>
          </Navbar.Link>

          <Navbar.Link>
            <a
              href="https://www.instagram.com/unithink.in/"
              target="_blank"
              rel="noopener noreferrer"
              className="text-gray-800 mr-8  hover:text-pink-500 transition duration-300 text-xl"
            >
              <BsInstagram />
            </a>
          </Navbar.Link>

          <Navbar.Link>
            <a
              href="https://twitter.com/Unithink_Edu"
              target="_blank"
              rel="noopener noreferrer"
              className="text-gray-800  hover:text-blue-400 transition duration-300 text-xl"
            >
              <BsTwitter />
            </a>
          </Navbar.Link>
        </div>


      </Navbar.Collapse>
    </Navbar>
  );
}

export default Header;
